import { commentItems } from '@/mocks/homeData';

export default function SectionComments() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-6xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading">剧迷热评</h2>
          <p className="mt-3 text-sm text-foreground-600">来自真实用户的追剧心声</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {commentItems.map((item) => (
            <div key={item.id} className="bg-background-100 rounded-xl p-6 border border-background-200/70">
              <div className="flex items-center gap-1 mb-3">
                {[...Array(item.rating)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-accent-500 text-xs"></i>
                ))}
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed">{item.content}</p>
              <div className="flex items-center gap-3 mt-5 pt-4 border-t border-background-200/70">
                <div className="w-10 h-10 rounded-full overflow-hidden bg-background-200 flex-shrink-0">
                  <img src={item.avatar} alt={item.user} className="w-full h-full object-cover" />
                </div>
                <div className="min-w-0">
                  <p className="text-sm font-semibold text-foreground-800">{item.user}</p>
                  <p className="text-xs text-foreground-500">{item.date}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}